import ComponentBootstrapper from "./ComponentBootstrapper";
import BundleWizard from "./components/BundleWizard/BundleWizard";
import Cart from "@app/react/components/Cart/Cart.jsx";
import CartReadonly from "@app/react/components/Cart/CartReadonly.jsx";
import BundleCategorySearch from "@app/react/components/BundleCategorySearch/BundleCategorySearch.jsx";
import CollectionBundles from "@app/react/components/CollectionBundles/CollectionBundles.jsx";
import BundleResultItems from "@app/react/components/BundleResultItems/BundleResultItems.jsx";
import ProductSearch from "@app/react/components/ProductSearch/ProductSearch.jsx";
import RegistrationModal from "@app/react/components/RegistrationModal/RegistrationModal.jsx";
import LoginForm from "@app/react/components/LoginForm/LoginForm.jsx";
import AddressCardSelector from "@app/react/components/AddressCardSelector/AddressCardSelector.jsx";

export default new ComponentBootstrapper({
  BundleWizard,
  Cart,
  CartReadonly,
  BundleCategorySearch,
  CollectionBundles,
  BundleResultItems,
  ProductSearch,
  RegistrationModal,
  LoginForm,
  AddressCardSelector,
})
